import React, { useEffect, useState } from "react";
import { AIRTABLE_URL, AIRTABLE_HEADERS } from "./constants";

export default function FullOrders() {
  const [orders, setOrders] = useState([]);
  const [statusMessages, setStatusMessages] = useState({});

  useEffect(() => {
    fetch(AIRTABLE_URL, {
      headers: AIRTABLE_HEADERS
    })
      .then(res => res.json())
      .then(data => {
        if (!data.records) {
          console.error("❌ No records returned:", data);
          return;
        }

        const parsed = data.records.map(rec => ({
          airtableId: rec.id,
          ...rec.fields
        }));

        setOrders(parsed);
      })
      .catch(err => console.error("❌ Fetch error:", err));
  }, []);

  const updateSheetRow = async (airtableId, updateData) => {
    try {
      const res = await fetch(`${AIRTABLE_URL}/${airtableId}`, {
        method: "PATCH",
        headers: AIRTABLE_HEADERS,
        body: JSON.stringify({ fields: updateData })
      });

      const result = await res.json();

      if (result.id) {
        setOrders(prev =>
          prev.map(o => o.airtableId === airtableId ? { ...o, ...updateData } : o)
        );
        setStatusMessages(prev => ({
          ...prev,
          [airtableId]: "✅ Technician assigned successfully!"
        }));
        setTimeout(() => {
          setStatusMessages(prev => {
            const updated = { ...prev };
            delete updated[airtableId];
            return updated;
          });
        }, 3000);
      } else {
        throw new Error("Update failed: " + JSON.stringify(result));
      }
    } catch (err) {
      console.error("❌ Update failed:", err.message);
      setStatusMessages(prev => ({
        ...prev,
        [airtableId]: "❌ Failed to assign technician."
      }));
      setTimeout(() => {
        setStatusMessages(prev => {
          const updated = { ...prev };
          delete updated[airtableId];
          return updated;
        });
      }, 3000);
    }
  };

  const parsePrice = str => {
  if (!str) return 0;
  const matches = [...str.matchAll(/₹\s?(\d+)/g)];
  return matches.reduce((sum, match) => sum + parseInt(match[1], 10), 0);
};


  const parseExtraPartsTotal = str => {
    if (!str || str.toLowerCase() === "none") return 0;
    return str.split(",").reduce((sum, part) => {
      const match = part.match(/₹\s?(\d+)/);
      return sum + (match ? parseInt(match[1], 10) : 0);
    }, 0);
  };

  const filteredOrders = orders.filter(o => {
  const pt = parseFloat(o.paymentTransferred || 0);
  return !pt && o.orderId && o.phone;
});


  return (
    <div style={{ paddingTop: 30, fontSize: 13 }}>
      <h2>Pending Orders and Payment</h2>
      {filteredOrders.length === 0 ? (
        <p>No pending payments.</p>
      ) : (
        filteredOrders.map((order, idx) => {
          const serviceCost = parsePrice(order.services);
          const extraPartsCost = parseExtraPartsTotal(order.extraParts);
          const grandTotal = serviceCost + extraPartsCost;

          return (
            <div key={idx} style={{
              border: "1px solid #ccc",
              padding: 15,
              marginBottom: 10,
              borderRadius: 8,
              background: "#f9f9f9"
            }}>
              <p><b>Order ID:</b> {order.orderId}</p>
              <p><b>Phone:</b> {order.phone}</p>
              <p><b>Services:</b> {order.services}</p>
              <p><b>Address:</b> {order.address}</p>
              <p><b>Pincode:</b> {order.pincode}</p>
              <p><b>Service Cost:</b> ₹{serviceCost.toFixed(2)}</p>
              <p><b>Extra Parts:</b> {order.extraParts || "None"}</p>
              <p><b>Extra Parts Cost:</b> ₹{extraPartsCost.toFixed(2)}</p>
              <p><b>Grand Total:</b> ₹{grandTotal.toFixed(2)}</p>
              <p><b>Work Completed:</b> {order.workCompleted}</p>
              <p><b>Paid:</b> {order.paid}</p>
              <div style={{ marginTop: 10, marginRight: 20 }}>
                <label>Assign Technician:</label>
                <input
                  type="tel"
                  inputMode="numeric"
                  maxLength={10}
                  value={order.assignedTechnicianPhone || ""}
                  onChange={e => {
                    const value = e.target.value;
                    setOrders(prev =>
                      prev.map(o =>
                        o.airtableId === order.airtableId
                          ? { ...o, assignedTechnicianPhone: value }
                          : o
                      )
                    );
                  }}
                  style={{ marginLeft: 1,  }}
                />
                <button
                  onClick={() =>
                    updateSheetRow(order.airtableId, {
                      assignedTechnicianPhone: order.assignedTechnicianPhone?.trim() || undefined
                    })
                  }
                  style={{
                    marginLeft: 10,
                    background: "#007bff",
                    color: "#fff",
                    padding: "6px 6px",
                    border: "none",
                    borderRadius: 4,
                    cursor: "pointer"
                  }}
                >
                  Submit
                </button>
                <div style={{ marginTop: 10 }}>

                  <label>Payment Transferred:</label>
              <input
                type="tel"
                inputMode="numeric"
                placeholder="Enter payment amount"
                value={order.paymentTransferredInput || ""}
                onChange={(e) => {
                  const val = e.target.value;
                  setOrders(prev =>
                    prev.map(o =>
                      o.airtableId === order.airtableId
                        ? { ...o, paymentTransferredInput: val }
                        : o
                    )
                  );
                }}
                style={{ marginRight: 3 }}
              />
              <button
                onClick={() =>
                  updateSheetRow(order.airtableId, {
                    paymentTransferred: order.paymentTransferredInput
                  })
                }
                style={{
                  marginLeft: 7,
                    background: "#007bff",
                    color: "#fff",
                    padding: "6px 6px",
                    border: "none",
                    borderRadius: 4,
                    cursor: "pointer"
                }}
              >
                Submit
              </button>
              </div>
                {statusMessages[order.airtableId] && (
                  <p style={{
                    marginTop: 5,
                    fontWeight: "bold",
                    color: statusMessages[order.airtableId].startsWith("✅") ? "green" : "red"
                  }}>
                    {statusMessages[order.airtableId]}
                  </p>
                )}
              </div>
            </div>
          );
        })
      )}
    </div>
  );
}
